module.exports = __webpack_public_path__ + "static/media/reglamento_3.96046ecd.png";